import FormCreator from './FormCreator';
import FormObjSchema from './FormElements.schema';
import { FORM_ELEMENT_TYPES } from './FormElements.types';

FormCreator.Schema = FormObjSchema;
FormCreator.TYPES = FORM_ELEMENT_TYPES;

export default FormCreator;
